<template>
  <div id="payment-information">
    <div class="d-flex align-items-center justify-content-between mb-5">
      <h4 class="mb-0">{{ $t('homelab.labels.payment_information') }}</h4>
      <va-popover
          class="clickable"
          v-if="hasWriteAppointmentsPermissions"
          placement="left"
          :message="$t('homelab.buttons.update_payment')"
      >
        <span @click.prevent="isUpdatingPayment = true">
          <i class="px-3 mr-3" :class="{'glyphicon glyphicon-plus': !appointment.payment, 'fa fa-pencil': (appointment.payment !== null && appointment.payment !== undefined)}"></i>
        </span>
      </va-popover>
    </div>

    <div v-if="appointment.payment" class="row">

      <div class="col-12 col-md-6 mb-3">
        <label class="is-bold mb-0">{{ $t('homelab.labels.payment_date') }}</label>
        <br>
        <span>{{ appointment.payment.date | localTime('YYYY-MM-DD') }}</span>
      </div>

      <div class="col-12 col-md-6 mb-3">
        <label class="is-bold mb-0">{{ $t('homelab.labels.payment.status') }}</label>
        <br>
        <span v-if="appointment.payment.payment_status_id !== null">{{$t(`homelab.payment_statuses.${appointment.payment.payment_status_id}`)}}</span>
        <span v-else>N/A</span>
      </div>

      <div class="col-12 col-md-6 mb-3">
        <label class="is-bold mb-0">{{ $t('homelab.labels.payment.value') }}</label>
        <br>
        <span>{{`${appointment.payment.value}€`}}</span>
      </div>

      <div class="col-12 col-md-6 mb-3">
        <label class="is-bold mb-0">{{ $t('homelab.labels.payment.method') }}</label>
        <br>
        <span v-if="appointment.payment.payment_method_id !== null">{{$t(`homelab.labels.payment.methods.${appointment.payment.payment_method_id}`)}}</span>
        <span v-else>N/A</span>
      </div>

      <div class="col-12 col-md-6 mb-3" v-if="appointment.payment.payment_method_id === paymentMethods.MBW.id">
        <label class="is-bold mb-0">{{ $t('homelab.labels.payment.customer_name') }}</label>
        <br>
        <span>{{appointment.payment.customer_name || 'N/A'}}</span>
      </div>

      <div class="col-12 col-md-6 mb-3" v-if="appointment.payment.payment_method_id === paymentMethods.MBW.id">
        <label class="is-bold mb-0">{{ $t('homelab.labels.payment.customer_phone') }}</label>
        <br>
        <span>{{appointment.payment.customer_phone || 'N/A'}}</span>
      </div>

      <div class="col-12 col-md-6 mb-3" v-if="appointment.payment.payment_method_id === paymentMethods.CC.id">
        <label class="is-bold mb-0">{{ $t('homelab.labels.payment.cc_last_four') }}</label>
        <br>
        <span>{{appointment.payment.cc_last_four || 'N/A'}}</span>
      </div>

      <div class="col-12 col-md-6 mb-3" v-if="appointment.payment.payment_method_id === paymentMethods.CC.id">
        <label class="is-bold mb-0">{{ $t('homelab.labels.payment.cc_card_type') }}</label>
        <br>
        <span>{{appointment.payment.cc_card_type || 'N/A'}}</span>
      </div>

      <div class="col-12 col-md-6 mb-3" v-if="appointment.payment.payment_method_id === paymentMethods.CC.id">
        <label class="is-bold mb-0">{{ $t('homelab.labels.payment.cc_expiration_date') }}</label>
        <br>
        <span>{{appointment.payment.cc_expiration_date || 'N/A'}}</span>
      </div>

      <div class="col-12 col-md-6 mb-3" v-if="appointment.payment.payment_method_id === paymentMethods.MB.id">
        <label class="is-bold mb-0">{{ $t('homelab.labels.payment.mb_entity') }}</label>
        <br>
        <span>{{appointment.payment.mb_entity || 'N/A'}}</span>
      </div>

      <div class="col-12 col-md-6 mb-3" v-if="appointment.payment.payment_method_id === paymentMethods.MB.id">
        <label class="is-bold mb-0">{{ $t('homelab.labels.payment.mb_reference') }}</label>
        <br>
        <span>{{appointment.payment.mb_reference || 'N/A'}}</span>
      </div>

    </div>
    <div v-else class="text-center">
      {{$t('homelab.labels.no_payment')}}
    </div>

    <CreateOrUpdateAppointmentPayment
      v-if="isUpdatingPayment"
      :appointment="appointment"
      :payment="appointment.payment"
      @cancel="isUpdatingPayment = false"
      @appointment-payment-updated="onAppointmentPaymentUpdated"
    />
  </div>
</template>
<script>
import { mapState } from 'vuex'
import CreateOrUpdateAppointmentPayment from '@/components/homelab/appointments/CreateOrUpdateAppointmentPayment'
export default {
  props: {
    appointment: {
      type: Object,
      required: true
    }
  },
  components: {
    CreateOrUpdateAppointmentPayment
  },
  computed: {
    ...mapState('homelab', [
      'paymentTypes',
      'paymentMethods',
      'paymentStatuses'
    ]),
    homelabService: function () {
      return this.$store.state.services.find(service => service.url === this.$store.state.homelab_server)
    },
    hasWriteAppointmentsPermissions: function () {
      return this.homelabService && this.appointment && this.homelabService.user_permissions.some(permission => (permission.entity_id === null || permission.entity_id === this.appointment.entity.id) && permission.access_type > 1 && permission.info_type === 100)
    }
  },
  data: function () {
    return {
      isUpdatingPayment: false,
    }
  },
  methods: {
    onAppointmentPaymentUpdated: function (payload) {
      this.$emit('appointment-payment-updated', payload)
    }
  }
}
</script>
